import http from '../HttpWrapper'

export type KernelTurnRole = 'user' | 'agent' | 'tool_call' | 'tool_result'
export type KernelTurnDbSourceTag = 'Graph' | 'Cold Storage' | 'Contxt PG'

export type KernelChatDto = {
    id: string
    title: string
    createdAt: string
    lastTurnCreatedAt: string | null
    turnCount: number
}

export type KernelTurnDto = {
    id: string
    role: KernelTurnRole
    index: number
    createdAt: string
    text: string | null
    tokensIn: number | null
    tokensOut: number | null
    toolName: string | null
    toolCallId: string | null
    toolArgumentsJson: string | null
    toolResultJson: string | null
    isError: boolean | null
    dbSourceTags: KernelTurnDbSourceTag[]
}

export type GetKernelChatsRes = {
    chats: KernelChatDto[]
}

export type GetKernelChatRes = {
    chat: KernelChatDto | null
    turns: KernelTurnDto[]
}

export type SendKernelMessageReq = {
    message: string
    chatId?: string
}

export type SendKernelMessageRes = {
    chat: KernelChatDto
    turns: KernelTurnDto[]
}

class KernelApi {
    private static instance: KernelApi

    public constructor() {
        if (KernelApi.instance) {
            return KernelApi.instance
        }

        KernelApi.instance = this
    }

    public async getChats(): Promise<GetKernelChatsRes> {
        return await http.get<GetKernelChatsRes>('/kernel/chats')
    }

    public async getChat(chatId: string): Promise<GetKernelChatRes> {
        const queryParams = new URLSearchParams({ chatId })
        return await http.get<GetKernelChatRes>('/kernel/chat', queryParams)
    }

    public async sendMessage(
        req: SendKernelMessageReq,
    ): Promise<SendKernelMessageRes> {
        return await http.post<SendKernelMessageReq, SendKernelMessageRes>(
            '/kernel/send-message',
            req,
        )
    }
}

const kernelApi = new KernelApi()
export default kernelApi
